// AUTO-GENERATED by shared/generators/config_enums_generator.py — do not edit.
// JobPostingStatus — source: shared/config/recruiting_job_posting_status.config.json
import type { ConfigStatusTone } from './config-status-tone';

export const JOB_POSTING_STATUS_VALUES = ["draft", "internal", "published", "paused", "closed", "filled"] as const;
export type JobPostingStatus = (typeof JOB_POSTING_STATUS_VALUES)[number];

export const jobPostingStatusTone: Record<JobPostingStatus, ConfigStatusTone> = {
  "draft": "neutral",
  "internal": "info",
  "published": "success",
  "paused": "warning",
  "closed": "neutral",
  "filled": "success",
};

export const jobPostingStatusIsTerminal: Record<JobPostingStatus, boolean> = {
  "draft": false,
  "internal": false,
  "published": false,
  "paused": false,
  "closed": true,
  "filled": true,
};

